import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,  
  MatDialogModule,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MonthPerformanceService } from '../service/month-performance.service';
import { Observable, fromEvent, map } from 'rxjs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import * as pdfjs from 'pdfjs-dist';
const pdfWorker = "../../assets/pdf.worker.mjs";
@Component({
  selector: 'app-attachment-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle, 
    MatDialogContent,
    MatDialogModule, 
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,    
    MatToolbarModule,
    TranslateModule,
  ],
  templateUrl: './attachment-dialog.component.html',
  styleUrl: './attachment-dialog.component.css'
})
export class AttachmentDialogComponent {
  color : ThemePalette = 'accent';
  constructor(@Inject(MAT_DIALOG_DATA) 
    public data: any,
    private sanitizer: DomSanitizer,
    private monthPerformanceService: MonthPerformanceService,
    translate: TranslateService, 
  ) {
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse); 
  }
  wordFormat = 'doc';
  wordUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=';
  showWord = false;
  trustedWordUrl! : SafeResourceUrl;
  showImg = false;
  imgBase64String = '';
  trustedImgUrl! : SafeResourceUrl;
  showPdf = false;
  pdfBase64String = '';
  trustedPdfUrl! : SafeResourceUrl;
  isLoading = false;
  toBase64(blob: Blob): Observable<string> {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return fromEvent(reader, 'load')
      .pipe(map(() => (reader.result as string)))
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.monthPerformanceService.getOthersKpiAttachmentV2(this.data.kpi?.kpiOthers_Id).subscribe(responseOthersKpiAttachment => {
      let index = this.data.kpi.attachment.lastIndexOf('.');
      let format = this.data.kpi.attachment.substring(index + 1);
      let formatLowerCase = format.toLowerCase();    
      if(formatLowerCase.includes('pdf')){
        this.showPdfDocV3(responseOthersKpiAttachment);
        // this.showPdfDocV5(this.data.kpi.getAttachmentS3Url);
        this.showPdf = true;
      }
      if(formatLowerCase.includes('jpg')  ){
        this.showJpg(responseOthersKpiAttachment);
        // this.showJpgV2(this.data.kpi.getAttachmentS3Url);
        this.showImg = true;
      }
      if(formatLowerCase.includes('png') ){      
        this.showJpg(responseOthersKpiAttachment);
        // this.showJpgV2(this.data.kpi.getAttachmentS3Url);      
        this.showImg = true;
      }
      this.isLoading = false;
  });
  }


  pdfURL() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfBase64String);
  }

  pdfURL2() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
  }

  jpgUrl!:any;
  jpgSafeUrl(){
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.jpgUrl);
  }

  showJpg(binaryData:Blob){
    var objectURL = URL.createObjectURL(binaryData);
    this.jpgUrl = objectURL;
  }
  showJpgV2(urlString:string){    
    this.jpgUrl = urlString;
  }

  showPDF(base64Data:string) {
    var binaryData = atob(base64Data);
    // Create a Uint8Array from the binary data
    var uint8Array = new Uint8Array(binaryData.length);
    for (var i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    var blob = new Blob([uint8Array], { type: 'application/pdf' });

    // Create an object URL for the blob
    var objectURL = URL.createObjectURL(blob);
    this.pdfUrl = objectURL;

    // Display the PDF using <embed> or <iframe>
    // document.getElementById('pdf-container').innerHTML = `
    // <embed src="${objectURL}" type="application/pdf" width="100%" height="500px">
    // `;

  }

  showPdfV2(binaryData:Blob) {
    // var binaryData = atob(base64Data);
    // // Create a Uint8Array from the binary data
    // var uint8Array = new Uint8Array(binaryData.length);
    // for (var i = 0; i < binaryData.length; i++) {
    //     uint8Array[i] = binaryData.charCodeAt(i);
    // }

    // // Create a Blob from the Uint8Array
    // var blob = new Blob([uint8Array], { type: 'application/pdf' });

    // Create an object URL for the blob
    // var objectURL = URL.createObjectURL(blob);
    var objectURL = URL.createObjectURL(binaryData);
    this.pdfUrl = objectURL;

    // Display the PDF using <embed> or <iframe>
    // document.getElementById('pdf-container').innerHTML = `
    // <embed src="${objectURL}" type="application/pdf" width="100%" height="500px">
    // `;

  }

  showPdfV3(binaryData:Blob) {
    // var binaryData = atob(base64Data);
    // // Create a Uint8Array from the binary data
    // var uint8Array = new Uint8Array(binaryData.length);
    // for (var i = 0; i < binaryData.length; i++) {
    //     uint8Array[i] = binaryData.charCodeAt(i);
    // }

    // // Create a Blob from the Uint8Array
    var blob = new Blob([binaryData], { type: 'application/pdf' });

    // Create an object URL for the blob
    var objectURL = URL.createObjectURL(blob);
    // var objectURL = URL.createObjectURL(binaryData);
    this.pdfUrl = objectURL;

    // Display the PDF using <embed> or <iframe>
    // document.getElementById('pdf-container').innerHTML = `
    // <embed src="${objectURL}" type="application/pdf" width="100%" height="500px">
    // `;

  }



  
  pdfUrl!:any;
  safePdfUrl!:any;

  @ViewChild('pdfViewer') pdfViewer!: ElementRef;
  async showPdfDocV3(binaryData:Blob) { 
    

    
    pdfjs.GlobalWorkerOptions.workerSrc =  pdfWorker;

    const buffer = await binaryData.arrayBuffer();

    
    pdfjs.getDocument(buffer).promise.then(pdf => {
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        pdf.getPage(pageNum).then(page => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const viewport = page.getViewport({ scale: 1.0 });

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context!,
            viewport: viewport
          };

          page.render(renderContext);
          this.pdfViewer.nativeElement.appendChild(canvas);
        });
      }
    });
  }

  async showPdfDocV5(urlString:string) { 
    pdfjs.GlobalWorkerOptions.workerSrc =  pdfWorker;
    pdfjs.getDocument({
      url: urlString,      
      cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.9.179/cmaps/',
      cMapPacked: true,
    }).promise.then(pdf => {
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        pdf.getPage(pageNum).then(page => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const viewport = page.getViewport({ scale: 1.0 });

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context!,
            viewport: viewport
          };
          page.render(renderContext);
          this.pdfViewer.nativeElement.appendChild(canvas);
        });
      }
    });
  }


}
